module.exports = __webpack_public_path__ + "static/media/YM64_2.e5349d28.jpg";